import React, {ComponentType} from "react";
import {css} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<IIcon>;
    text: string;
    isArchived?: boolean;
    isUnavailable?: boolean;
}

export const OfferBoxPill = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div className={wrapperStyle}>
            {!props.isArchived && (
                <div className={iconWrapperStyle}>
                    <Icon size="1.6" />
                </div>
            )}
            <Text variant="info_txt_1" color={props.isArchived || props.isUnavailable ? "var(--colors-gray-100)" : "var(--colors-secondary)"} strong>
                {getPillText(props.text, props.isArchived, props.isUnavailable)}
            </Text>
        </div>
    );
};

const getPillText = (text: string, isArchived?: boolean, isUnavailable?: boolean) => {
    if (isUnavailable) {
        return "Oferta nieaktywna";
    }
    if (isArchived) {
        return "Oferta archiwalna";
    }
    return text;
};

const wrapperStyle = css({
    display: "inline-flex",
    alignItems: "center",
    py: 0,
    px: 1,
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: 1,
    gap: 1,
    height: "2.4rem",
    userSelect: "none"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.6rem",
    height: "1.6rem"
});
import React, {ComponentType} from "react";
import {css} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<IIcon>;
    text: string;
    isArchived?: boolean;
    isUnavailable?: boolean;
}

export const OfferBoxPill = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div className={wrapperStyle}>
            {!props.isArchived && (
                <div className={iconWrapperStyle}>
                    <Icon size="1.6" />
                </div>
            )}
            <Text variant="info_txt_1" color={props.isArchived || props.isUnavailable ? "var(--colors-gray-100)" : "var(--colors-secondary)"} strong>
                {getPillText(props.text, props.isArchived, props.isUnavailable)}
            </Text>
        </div>
    );
};

const getPillText = (text: string, isArchived?: boolean, isUnavailable?: boolean) => {
    if (isUnavailable) {
        return "Oferta nieaktywna";
    }
    if (isArchived) {
        return "Oferta archiwalna";
    }
    return text;
};

const wrapperStyle = css({
    display: "inline-flex",
    alignItems: "center",
    py: 0,
    px: 1,
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: 1,
    gap: 1,
    height: "2.4rem",
    userSelect: "none"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.6rem",
    height: "1.6rem"
});
